import React, { useState } from 'react';
import { useAuth } from '../../auth/useAuth';
import { Alert } from '../../services/Alert';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useHistory } from 'react-router';

export const UploadPage = () => {

    const history = useHistory();
    const [state, setstate] = useState({loading:false, files:[]})
    const user = useAuth();
    const config = user.config;
    
    if(user.errmsg !== ''){
        Alert(user.errmsg,'error',{});
        user.errclear();
    }

    const addList = (objNew) => {
        var bEncontrado = false;
        
        if(state.files.length >= 10){
            Alert('Se ha excedido el maximo de XML a subir','warning',{});
            return;
        }

        for (let iList = 0; iList < state.files.length; iList++) {
            const element = state.files[iList];

            if(element.name === objNew.name){
                bEncontrado = true;
            }
        }

        if(!bEncontrado){
            let tmpArchivo = state.files;
            tmpArchivo.push(objNew);
            setstate({...state, files: tmpArchivo});
        }
    }

    const handleRemove = (id) => {
        let tmpArchivo = state.files;
        
        for (let iList = 0; iList < tmpArchivo.length; iList++) {
            const element = tmpArchivo[iList];

            if(element.id === id){
                tmpArchivo.splice(iList,1);
            }
        }
        setstate({...state, files: tmpArchivo});
    }

    const handleChangeFile = (e) => {
        let objFiles = e.target.files;
        
        Array.from(objFiles).forEach( async (archivo) => {
            var reader = new FileReader();
            reader.readAsDataURL(archivo);
            reader.onload=function(){
                var auxb64=[];
                var base64 = reader.result;
                auxb64= base64.split(',');

                var idFile = 1;
                if(state.files.length>=1){
                    idFile = state.files[state.files.length - 1].id + 1;
                }

                let miarchivo = {id: idFile, name: archivo.name, size: archivo.size, type: archivo.type, data: auxb64[1], error:'' };
                addList(miarchivo);
            }
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        setstate({...state, loading: true });

        const getData = async() => {
            
            const BaseUrl = config.baseUrl || 'http://localhost/wservices/';
            const AppId = config.appId ||'';
            
            try{
                //console.log(state);
                const data = {
                    apikey: AppId || '',
                    action: 'subirxml',
                    provider: 'proveedor',
                    data: {
                        tabla: user.user.tabla || '',
                        clave: user.user.clave || '', 
                        usuario: user.user.usuario || '', 
                        files: state.files || [] 
                    }
                }
                
                await axios.post(BaseUrl, data,{ headers: {'Content-Type': 'application/json'}})
                .then(response => {

                    let data = response.data;
                    let jsonData = {}
                    if(data.type===undefined){
                        data = data.replaceAll('\\r\\n',' ')
                        data = data.replaceAll("\\'",' ')
                    }
                    jsonData = data;
                    
                    return jsonData
                })
                .then(datos => {
                    setstate({...state, loading: false });
                    
                    if((datos.type || '') === ''){
                        console.log(datos.type);
                        Alert('Advertencia: No hubo respuesta del servidor','warning',{});
                        return;
                    }
                    
                    //Ya tenemos una respuesta valida, ahora la procesamos
                    if(datos.type === 'error'){
                        Alert('Advertencia: '+ datos.code + ' - ' + datos.message,'warning',{});
                        return;
                    }
                    
                    const resultado = datos.data || {};
                    
                    if(resultado.files !== undefined){
                        if(resultado.files.length){
                            let tmpArchivos = state.files;
                            let cambiado = false;
                            //Procesamos para mostrar los errores en los archivos correctos
                            resultado.files.forEach(element => {
                                for(var i = 0; i < tmpArchivos.length; i++){
                                    if(tmpArchivos[i].name.toUpperCase()===element.name.toUpperCase()){
                                        tmpArchivos[i].error = element.message;
                                        cambiado = true;
                                    }
                                }
                            });

                            if(cambiado){
                                setstate({ ...state, files: tmpArchivos});
                            }
                        }
                    }

                    if(resultado.folio===''){
                        Alert('La carga de archivos tuvo problemas, revisar los detalles en la lista de archivos','warning',{});
                        return;
                    }

                    setstate({...state,files: [], folio: resultado.folio });

                    Alert('Archivos subidos con exito','info',{});
                    history.push('/acuse/' + (resultado.folio || ''));
                    
                }).catch(error => {
                    setstate({...state, loading: false });
                    Alert('Error: '+error.message,'error',{});
                    console.log(error);
                });
            }catch(error){
                setstate({...state, loading: false });
                Alert('Error: '+error.message,'error',{});
            }
        }

        getData();
    }

  return (
    <div className="container mt-5 mb-5">
        <div className='row'>
            <h1 className='m8-h2 animated fadeIn'>Subir facturas</h1>
        </div>
        <div className="row">
            <form name="formUpload" method="POST" onSubmit={(e)=>handleSubmit(e)}>
                <div className="mb-3">
                    <label htmlFor="xmlFiles" className="form-label form-label-sm m8-ilabel">Cargar arhivos XML</label>
                    <input className="form-control m8-itext" type="file" id="xmlFiles" name="xmlFiles" accept="text/xml" multiple onChange={(e)=>handleChangeFile(e)} />
                </div>
                <button type="submit" className="btn btm-sm m8-btn-submit m8-itext" disabled={ state.loading ? "disabled" : "" }>
                    <span className={!state.loading?"visually-hidden spinner-border spinner-border-sm":"spinner-border spinner-border-sm"} role="status" aria-hidden="true"></span> Enviar
                </button>
            </form>
            <div className="mb-3 mt-3">
                <ul className="list-group">
                    {
                        state.files.map(row => (
                            <li key={ row.id || 0 } className="list-group-item d-flex justify-content-between align-items-center m8-itext">
                                { row.name || 'fake.xml' } ( { ((row.size || 0) / 1024).toFixed(0) } KB) <br /><small className="">{ row.error }</small>
                                <span 
                                    className="badge rounded-pill bg-danger btn btn-sm m8-btn-b3" 
                                    onClick={ ()=>handleRemove(row.id) }
                                >Eliminar</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
        <ToastContainer />
    </div>
  )
}